/**
 * Team Grid Swipe/Carousel Functionality
 * Enables smooth swiping and touch-based horizontal scrolling for team members on mobile
 */

(function () {
    'use strict';

    // Initialize team grid swipe functionality
    function initTeamGridSwipe() {
        const teamGrid = document.querySelector('.team-grid');
        if (!teamGrid) return;

        // Only initialize on mobile/tablet
        if (window.innerWidth > 768) return;

        let isDown = false;
        let startX;
        let scrollLeft;
        let startTime;

        // Mouse down - start tracking
        teamGrid.addEventListener('mousedown', function (e) {
            isDown = true;
            startX = e.pageX - teamGrid.offsetLeft;
            scrollLeft = teamGrid.scrollLeft;
            startTime = Date.now();
            teamGrid.style.cursor = 'grabbing';
        });

        // Mouse leave - stop tracking
        teamGrid.addEventListener('mouseleave', function () {
            isDown = false;
            teamGrid.style.cursor = 'grab';
        });

        // Mouse up - stop tracking
        teamGrid.addEventListener('mouseup', function () {
            isDown = false;
            teamGrid.style.cursor = 'grab';
        });

        // Mouse move - handle drag
        teamGrid.addEventListener('mousemove', function (e) {
            if (!isDown) return;
            e.preventDefault();

            const x = e.pageX - teamGrid.offsetLeft;
            const walk = (x - startX) * 1; // 1 = scroll speed
            teamGrid.scrollLeft = scrollLeft - walk;
        });

        // Touch events for mobile
        let touchStartX = 0;
        let touchStartTime = 0;

        teamGrid.addEventListener('touchstart', function (e) {
            touchStartX = e.touches[0].clientX;
            touchStartTime = Date.now();
        });

        teamGrid.addEventListener('touchend', function (e) {
            const touchEndX = e.changedTouches[0].clientX;
            const touchDuration = Date.now() - touchStartTime;
            const distance = touchStartX - touchEndX;
            const speed = Math.abs(distance) / touchDuration;

            // Apply momentum scrolling for quick swipes
            if (speed > 0.5 && distance !== 0) {
                const momentum = distance > 0 ? 30 : -30;
                const finalScroll = teamGrid.scrollLeft + (distance + momentum);

                teamGrid.scrollTo({
                    left: finalScroll,
                    behavior: 'smooth'
                });
            }
        });

        // Add snap scrolling effect - snap to card boundaries
        let scrollTimeout;
        teamGrid.addEventListener('scroll', function () {
            clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(function () {
                const cards = teamGrid.querySelectorAll('.team-card');
                if (cards.length === 0) return;

                const scrollLeft = teamGrid.scrollLeft;
                const cardWidth = cards[0].offsetWidth;
                const gap = 24; // matches gap in CSS (1.5rem = 24px)

                // Find the closest card
                let closestIndex = 0;
                let closestDistance = Math.abs(scrollLeft);

                cards.forEach((card, index) => {
                    const cardPosition = (cardWidth + gap) * index;
                    const distance = Math.abs(scrollLeft - cardPosition);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestIndex = index;
                    }
                });

                // Snap to the closest card
                const snapPosition = (cardWidth + gap) * closestIndex;
                teamGrid.scrollTo({
                    left: snapPosition,
                    behavior: 'smooth'
                });
            }, 150);
        });
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTeamGridSwipe);
    } else {
        initTeamGridSwipe();
    }

    // Re-initialize on window resize
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            // Re-check if we're on mobile
            if (window.innerWidth <= 768) {
                initTeamGridSwipe();
            }
        }, 250);
    });
})();
